import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Popover from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import GallectionListItemButton from '../../GallectionListItem/GallectionListItemButton';
import ScrollableContent from '../../ScrollableContent';
import s from './GroupGallectionPopover.scss';
const GroupGallectionPopover = ({ isVisible, isReduxReady, group, selected, onSelect, gallections, gallectionType, fetchGallections, requestClose })=>{
    const { t } = useTranslation();
    const [isFetching, setIsFetching] = useState(false);
    const { userId } = group;
    // Fetch gallections
    useEffect(()=>{
        if (!gallections && !isFetching && isReduxReady) {
            setIsFetching(true);
            fetchGallections(userId, gallectionType);
        }
    }, [
        gallections,
        isReduxReady,
        isFetching,
        fetchGallections,
        gallectionType,
        userId
    ]);
    // Preselect featured folder
    useEffect(()=>{
        if (selected || !onSelect) {
            return;
        }
        if (gallections === null || gallections === void 0 ? void 0 : gallections.length) {
            onSelect(gallections[0]);
        }
    }, [
        gallections,
        selected,
        onSelect
    ]);
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        width: 390,
        onClickOutside: requestClose,
        placement: "bottom",
        secondaryPlacement: "end",
        usePortal: true,
        popoverContent: /*#__PURE__*/ React.createElement(Popover, {
            heading: t('groupGallectionSelector.popover.heading', {
                groupname: group.username
            }),
            onCloseClick: requestClose,
            className: s['root'],
            contentClassName: s['content'],
            showHeaderBorder: true,
            content: /*#__PURE__*/ React.createElement(ScrollableContent, {
                className: s['scrollable']
            }, gallections === null || gallections === void 0 ? void 0 : gallections.map((gallection)=>/*#__PURE__*/ React.createElement(GallectionListItemButton, {
                    key: gallection.folderId,
                    gallection: gallection,
                    onClick: ()=>{
                        onSelect && onSelect(gallection);
                        requestClose();
                    },
                    className: s['item'],
                    checked: gallection.folderId === (selected === null || selected === void 0 ? void 0 : selected.folderId)
                })))
        })
    });
};
GroupGallectionPopover.displayName = 'GroupGallectionPopover';
export default GroupGallectionPopover;
